/** @format */

import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
  getTermDataStart,
  setTermDepartment,
  setTermPosition,
  setTermNoc,
  setTermNavitaire,
  setTermUber,
  setTermLyft,
} from '../../redux/termination/termination.actions';
import { selectCurrentUser } from '../../redux/user/user.selector';
import {
  selectTermDepartments,
  selectTermDepartment,
  selectTermPosition,
} from '../../redux/termination/termination.selector';
import Multiselect from 'multiselect-react-dropdown';
import { Container } from '@mui/material';
import './termination-page.styles.scss';
import TerminationForm from '../../components/termination-form/termination-form.component';

const TerminationPage = ({
  dispatchGetTermDataStart,
  departments,
  currDepartment,
  currPosition,
  setTermDepartment,
  setTermPosition,
  setTermNoc,
  setTermNavitaire,
  setTermUber,
  setTermLyft,
}) => {
  const [positions, setPositions] = useState(null);

  const departmentMultiselectRef = useRef(null);
  const positionMultiselectRef = useRef(null);

  useEffect(() => {
    dispatchGetTermDataStart();
  }, [dispatchGetTermDataStart]);

  useEffect(() => {
    if (departmentMultiselectRef.current !== null) {
      let selectedDepartments =
        departmentMultiselectRef.current.getSelectedItems();
      if (selectedDepartments.length >= 1) {
        setPositions(selectedDepartments[0].positions);
      }
    }
  }, [departmentMultiselectRef]);

  const onDepartmentSelect = (_selectedList, selectedItem) => {
    setTermDepartment(selectedItem.name);
    setPositions(selectedItem.positions);
  };

  const onDepartmentRemove = () => {
    setPositions(null);
    setTermDepartment(null);
    setTermPosition(null);
    setTermNoc(null);
    setTermNavitaire(null);
    setTermUber(null);
    setTermLyft(null);
  };

  const onPositionSelect = (_selectedList, selectedItem) => {
    setTermPosition(selectedItem.title);
    setTermNoc(selectedItem.raido);
    setTermNavitaire(selectedItem.navitaire);
    setTermUber(selectedItem.uber);
    setTermLyft(selectedItem.lyft);
  };

  const onPositionRemove = () => {
    setTermPosition(null);
    setTermNoc(null);
    setTermNavitaire(null);
    setTermUber(null);
    setTermLyft(null);
  };

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '20px',
        backgroundColor: '#FFEBE6',
        borderRadius: '20px',
        boxShadow: '0px 0px 33px 25px #FF7575',
      }}
    >
      <h4 style={{ textAlign: 'center' }}>TERMINATION FORM</h4>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          padding: '20px',
        }}
      >
        <span>
          {departments && (
            <>
              <label> Departments:</label>
              <Multiselect
                isObject={true}
                options={departments}
                displayValue="name"
                selectionLimit={1}
                hidePlaceholder={true}
                avoidHighlightFirstOption={true}
                selectedValues={departments.filter(
                  (department) => department.name === currDepartment
                )}
                ref={departmentMultiselectRef}
                placeholder="Select a Department"
                onSelect={onDepartmentSelect}
                onRemove={onDepartmentRemove}
                style={{
                  chips: {
                    background: 'red',
                    color: 'white',
                    fontWeight: 'bold',
                  },
                  option: { fontSize: '15px' },
                  searchBox: {
                    backgroundColor: 'white',
                    border: '1px solid black',
                  },
                  groupHeading: {
                    fontWeight: 'bold',
                    color: 'white',
                    fontSize: '20px',
                    backgroundColor: 'red',
                    padding: '3px',
                  },
                  optionContainer: {
                    // To change css for option container
                    height: '200px',
                  },
                }}
              />
            </>
          )}
        </span>

        <span>
          {positions && (
            <>
              <label> Positions:</label>

              <Multiselect
                isObject={true}
                options={positions}
                displayValue="title"
                onSelect={onPositionSelect}
                onRemove={onPositionRemove}
                selectedValues={positions.filter(
                  (position) => position.title === currPosition
                )}
                preSelectedValues={positions.filter(
                  (position) => position.title === currPosition
                )}
                ref={positionMultiselectRef}
                selectionLimit={1}
                hidePlaceholder={true}
                placeholder="Select a Position"
                avoidHighlightFirstOption={true}
                style={{
                  chips: {
                    background: 'red',
                    color: 'white',
                    fontWeight: 'bold',
                  },
                  option: { fontSize: '15px' },
                  searchBox: {
                    backgroundColor: 'white',
                    border: '1px solid black',
                  },
                  groupHeading: {
                    fontWeight: 'bold',
                    color: 'white',
                    fontSize: '20px',
                    backgroundColor: 'red',
                    padding: '3px',
                  },
                  optionContainer: {
                    // To change css for option container
                    height: '200px',
                  },
                }}
              />
            </>
          )}
        </span>
      </Container>
      <Container
        sx={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        {currDepartment && currPosition && <TerminationForm />}
      </Container>
    </Container>
  );
};

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
  departments: selectTermDepartments,
  currDepartment: selectTermDepartment,
  currPosition: selectTermPosition,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchGetTermDataStart: () => dispatch(getTermDataStart()),
  setTermDepartment: (department) => dispatch(setTermDepartment(department)),
  setTermPosition: (position) => dispatch(setTermPosition(position)),
  setTermNoc: (obj) => dispatch(setTermNoc(obj)),
  setTermNavitaire: (obj) => dispatch(setTermNavitaire(obj)),
  setTermUber: (obj) => dispatch(setTermUber(obj)),
  setTermLyft: (obj) => dispatch(setTermLyft(obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TerminationPage);
